// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Form = require("./Form.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let JsxRuntime = require("react/jsx-runtime");

function FormalityUI$FieldValidationMessage(props) {
  let result = props.result;
  if (result !== undefined && result.TAG !== "Ok") {
    return JsxRuntime.jsx(Form.$$Error.make, {
      children: props.messageToString(result._0)
    });
  } else {
    return null;
  }
}

let FieldValidationMessage = {
  make: FormalityUI$FieldValidationMessage
};

function FormalityUI$AsyncFieldValidationMessage(props) {
  let result = props.result;
  if (result === undefined) {
    return null;
  }
  if (result.TAG === "Validating") {
    return null;
  }
  let message = result._0;
  if (message.TAG === "Ok") {
    return null;
  } else {
    return JsxRuntime.jsx(Form.$$Error.make, {
      children: props.messageToString(message._0)
    });
  }
}

let AsyncFieldValidationMessage = {
  make: FormalityUI$AsyncFieldValidationMessage
};

function ofFieldResult(result) {
  if (result.TAG === "Ok") {
    return "ok";
  } else {
    return "error";
  }
}

function ofOptFieldResult(v) {
  return Stdlib_Option.map(v, ofFieldResult);
}

function ofAsyncFieldResult(result) {
  if (result.TAG === "Validating") {
    return;
  } else if (result._0.TAG === "Ok") {
    return "ok";
  } else {
    return "error";
  }
}

function ofOptAsyncFieldResult(v) {
  return Stdlib_Option.flatMap(v, ofAsyncFieldResult);
}

let UIKitStatus = {
  ofFieldResult: ofFieldResult,
  ofOptFieldResult: ofOptFieldResult,
  ofAsyncFieldResult: ofAsyncFieldResult,
  ofOptAsyncFieldResult: ofOptAsyncFieldResult
};

exports.FieldValidationMessage = FieldValidationMessage;
exports.AsyncFieldValidationMessage = AsyncFieldValidationMessage;
exports.UIKitStatus = UIKitStatus;
/* Form Not a pure module */
